var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"playback-time"},[_c('div',{staticClass:"aisea-text-20-400-white"},[_vm._v("\n    "+_vm._s(_vm.now)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }